import React from 'react'
import Page from '../../pages/components/Page'
import NewRequest from './NewRequest'
import Breadcrumbs from '../../components/Breadcrumbs'
import ItemsRequestsApp from './ItemsRequestsApp'
import BetaLabel from '../admin/components/BetaLabel'

export default function NewRequestStaffPage() {

    const itemsRequestApp = new ItemsRequestsApp()

    return(
        <Page>
            <div className="view-single-request-page-container content-section-wrapper page-container-wrapper">

                <div className="page-container-head-box" style={{ marginBottom: 35 }}>
                    <div className="content-of-page-container-head-box">
                        <h2>
                            New Request
                            {itemsRequestApp.isBeta && <BetaLabel />}
                        </h2>

                        <Breadcrumbs breadcrumbs={[
                            {
                                title: "Home",
                                link: "/"
                            },
                            {
                                title: "My Requests",
                                link: "/requests"
                            },
                            {
                                title: "New Request"
                            }
                        ]} />
                    </div>
                </div>

                <NewRequest hidePageHeadSection staffPage />
            </div>
        </Page>
    )
}